export const STORE_LOAN_REQUEST = 'user.borrower.store_loan.STORE_LOAN_REQUEST'
export const STORE_LOAN_SUCCESS = 'user.borrower.store_loan.STORE_LOAN_SUCCESS'
export const STORE_LOAN_FAILURE = 'user.borrower.store_loan.STORE_LOAN_FAILURE'
